import moment from 'moment';
import { omit } from 'lodash';
import { getOrders, getOrderTotals } from '../../../HttpRequests/orders'
import { setFetching } from '../State/fetching';
import { loadOrders } from '../State/orders';
import { loadOrderTotals } from '../State/orderTotals';
import { setPagination } from '../State/pagination';
import handleException from '../../../Core/Helpers/handleException';

export default () => async (dispatch, getState) => {

  const { pagination, sorting, searchTerm, filters } = getState().screens.Orders;

  try {

    const params = {};
    params.include = [
      'clientContact',
      'project',
      'project.clientSite',
      'project.clientSite.client',
      /* 'order_files' */
    ].join();

    params['page[size]'] = pagination.pageSize;
    params['page[number]'] = pagination.current;

    if (sorting.columnKey) {
      params.csort = (sorting.order === 'descend' ? '-' : '') + sorting.columnKey;
    }

    if (filters.quick_filter !== 'all') {
      params['filter[quick_filter]'] = filters.quick_filter;
    }

    if (searchTerm) {
      params.search = searchTerm;
    }

    if (filters.client_id > 0) {
      params['filter[client_id]'] = filters.client_id;//.join(',');
    }

    if (filters.extra_works !== 'all') {
      params['filter[extra_works]'] = filters.extra_works;
    }

    if (Array.isArray(filters.date_between) && filters.date_between.length === 2)  {
      params['filter[date_between]'] = filters.date_between.map(date => moment(date).format('YYYY-MM-DD')).join();
    }

    if (filters.po_loaded !== 'all') {
      params['filter[po_loaded]'] = filters.po_loaded;
    }

    if (filters.sent_to_subcontractor !== 'all') {
      params['filter[sent_to_subcontractor]'] = filters.sent_to_subcontractor;
    }

    if (filters.procurement_only !== 'all') {
      params['filter[procurement_only]'] = filters.procurement_only;
    }

    dispatch(setFetching(true));

    const response = await getOrders({ params });

    dispatch(loadOrders(response.data.data));

    dispatch(setPagination({
      total: response.data.pagination.total,
      pageSize: response.data.pagination.per_page,
      current: response.data.pagination.current_page
    }));

    dispatch(setFetching(false))

    const response2 = await getOrderTotals({ params: omit(params, [ 'page[size]', 'page[number]', 'csort' ]) });

    dispatch(loadOrderTotals(response2.data.data));

  } catch (error) {

    handleException(error);

  }
}
